import React, { useCallback, useMemo } from 'react';

import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Hotkey } from 'ui-components/components/hotkey';

import { scanToPrintPrintHotkey as scanToPrintPrintHotkeyAction } from '../../store/scan-to-print/scan-to-print.actions';
import { useIsAccountEmailVerifiedSellerSetting } from '../../hooks/use-seller-setting';
import { useModal } from '../../hooks/use-modal';
import { VerifyEmailModal } from '../../components/verify-email-modal';
import { SCAN_TO_PRINT } from '../../constants/email-resend-source';

const messages = defineMessages({
  name: {
    description: 'modalHotkey.scanToPrint',
    defaultMessage: 'Scan To Print',
    id: 'U2sgr4',
  },
});

export const ScanToPrintHotkey = ({ children, isDisabled = false }) => {
  const isAccountEmailVerified = useIsAccountEmailVerifiedSellerSetting();

  const { close: closeUnverifiedModal, isOpen: isUnverifiedModalOpen, open: openUnverifiedModal } = useModal();
  const dispatch = useDispatch();
  const onScanToPrint = useCallback(() => {
    if (!isAccountEmailVerified) {
      openUnverifiedModal();
      return;
    }
    // TODO: Add a check to see if the seller's wallet is setup or not - Greg S. 10/1/24
    dispatch(scanToPrintPrintHotkeyAction(isDisabled));
  }, [dispatch, isAccountEmailVerified, isDisabled, openUnverifiedModal]);
  const intl = useIntl();

  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: ['p'],
      barcode: '+ADOEJDLAS77=',
      hotkey: ['p'],
      // this call reaches "into" the job pipeline
      // from outside of it, and probably shouldn't
      handler: onScanToPrint,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
    }),
    [intl, onScanToPrint],
  );

  return (
    <>
      <Hotkey hotkey={hotkeyMetadata}>{children}</Hotkey>
      {isUnverifiedModalOpen && <VerifyEmailModal closeUnverifiedModal={closeUnverifiedModal} source={SCAN_TO_PRINT} />}
    </>
  );
};

ScanToPrintHotkey.propTypes = {
  children: PropTypes.node.isRequired,
  isDisabled: PropTypes.bool,
};

export default ScanToPrintHotkey;
